import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Modal from "components/utils/Modal";
import FormStyledButton, {
  StyledLink
} from "components/forms/FormStyledButton";
import { PortalWithState } from "react-portal";

const FormStyledButtonLink = styled(StyledLink)`
  background: ${props => props.theme.colors.red};
  color: #ffffff;
  border: none;
  margin: auto;
  text-align: center;

  &:hover,
  &:focus {
    background: ${props => props.theme.colors.lightCoral};
    color: #ffffff;
  }

  &:last-of-type {
    margin-top: 20px;
  }
`;

const SignupFailureModal = ({
  backgroundIds,
  email,
  existingUser,
  onDismiss
}) => {
  return (
    <PortalWithState defaultOpen>
      {({ closePortal, portal }) =>
        portal(
          <Modal
            closePortal={closePortal}
            key="existing-modal"
            backgroundIds={backgroundIds}
          >
            <h3 key="modal-header">Unable to submit request</h3>

            {existingUser && email ? (
              <>
                <p key="modal-duplicateEmail" style={{ display: "block" }}>
                  That email address already has a SuperCarers account. Click
                  below to access your care hub. Or If you believe this to be a
                  mistake please call us on 020 8629 1030.
                </p>
                <FormStyledButtonLink
                  href={`${window.SUPERCARERS_APP_URL}/?email=${email}`}
                >
                  Take me to my care hub
                </FormStyledButtonLink>
              </>
            ) : (
              <>
                <p key="modal-unknownError" style={{ display: "block" }}>
                  Something went wrong. Please call us on 020 8629 1030. Sorry
                  for any inconvenience.
                </p>
                <FormStyledButton
                  key="modal-next"
                  style={{ width: "auto", padding: "10px 10px" }}
                  onClick={onDismiss}
                >
                  I understand
                </FormStyledButton>
              </>
            )}
          </Modal>
        )
      }
    </PortalWithState>
  );
};

SignupFailureModal.propTypes = {
  backgroundIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  email: PropTypes.string.isRequired,
  existingUser: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired
};

export default SignupFailureModal;
